module.exports = __webpack_public_path__ + "img/googleanalytics.57833383.png";